<template>
    <div>
        <div class="" v-if="hasAlerts">
                <div v-for="alert in badgeData.BadgeAlertList" :key="alert.id" :value="alert.id" :class="alertClass(alert)" >

                    <label class="alerttextbold alertline1" v-html="alert.alertLine1"> </label>
                    <button class="dismissbutton alertdismissbutton" @click="dismissalert(alert)" v-if="alert.canBeDismissed">X</button>
                    <button class="tbuttondown alerttogglebutton" @click="togglealert(alert)" v-if="showdown(alert)">&#9660</button>
                    <button class="tbuttonup alerttogglebutton" @click="togglealert(alert)" v-if="showup(alert)">&#9650</button>
                    <label class="alerttext  alertline2" v-html="alert.alertLine2"></label>

                </div>
        </div>
    </div>
  </template>
  
  <script>
import {mapFields} from 'vuex-map-fields'
import badge from '../services/badge.js'
 import style from '../style.js'
  export default {
    mixins:[style, badge],
      components:{

      },
      name:"badgealert",
      props:{
           
      },
      data(){
          return{
             
          }
      },
      computed:{
        ...mapFields([
            'badgeData'
            
        ]),
      },
      methods:{
          
      }
  }
  </script>
  
  <style>
  /* ALERT */
.alert{
    padding:10px;
}
.alertdivunread{
    opacity:1;
}
.alertdiv{
    padding:5px;
    background-color: var(--alert-color);
    margin:2px;
    display:grid;
    grid-template-columns:8fr 1fr;
    grid-template-rows:auto auto;
    grid-template-areas: 
        "line1 dismiss"
        "line2 toggle";

}
.alertline1{
    grid-area:line1;
}
.alertline2{
    grid-area:line2;
   
    
}
.alertdismissbutton{
    grid-area:dismiss;
}
.alerttogglebutton{
    grid-area:toggle;
}
.alertdivread{
    opacity:.6;
}
.alerttall{
    height:auto;
}
.alertshort{
    height:50px;
}
.alerttext{
    color:var(--light-text-color);
    text-align:left;
}
.alerttextbold{
    color:var(--light-text-color);
    font-weight: bold;
    text-align:left;
}
.dismissbutton{
    border:none;
    background-color:transparent;
    color:white;
}
.tbuttondown{
    border:none;
    background-color:transparent;
    color:white;
    margin-bottom:35px;
}
.tbuttonup{
    border:none;
    background-color:transparent;
    color:white;
    margin-top:30px;
}
  </style>